import { instanceOf, string } from 'prop-types'
import cn from 'classnames'
import Post from '../../../../../models/Post.js'
import Settings from '../../../../../models/settings.js'
import SocialCommerce from '../../theme-components/social-commerce.js'

export default function CardsSocialCommerceButton({ feedKey, post, settings }) {
  const { allowCookies, enableWebAnalytics, socialCommerceButtonPosition } = settings
  const postHasImage = post.media.some((media) => media.isImage)

  return (
    <SocialCommerce
      allowCookies={allowCookies}
      className={cn('bzfy-o-commerce', {
        'bzfy-o-commerce--large': settings.socialCommerceButtonLarge,
        'bzfy-o-commerce--image': socialCommerceButtonPosition === 'top' && postHasImage,
        'bzfy-o-commerce--bottom': socialCommerceButtonPosition === 'bottom',
      })}
      enableWebAnalytics={enableWebAnalytics}
      feedKey={feedKey}
      fromGate={false}
      post={post}
      settings={settings}
      target="_BLANK"
    />
  )
}

CardsSocialCommerceButton.propTypes = {
  feedKey: string.isRequired,
  post: instanceOf(Post).isRequired,
  settings: instanceOf(Settings).isRequired,
}
